/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 as Typography } from '@coursera/cds-core';

import RelatedDegree from 'bundles/premium-hub/components/career-module/RelatedDegree';
import RoleTestimonial from 'bundles/premium-hub/components/career-module/RoleTestimonial';
import type { CareerRolesModuleItem } from 'bundles/premium-hub/types';

type Props = {
  role?: CareerRolesModuleItem | null;
};

const styles = {
  testimonialContainer: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-400);
  `,
};

const CareerRolePanel = ({ role }: Props) => {
  if (!role) return null;

  const { roleDescription, testimonialImage, testimonialHeading, testimonialBody, relatedDegree } = role;

  return (
    <Grid container spacing={32}>
      <Grid item xs={12} md={6}>
        <Typography variant="bodyPrimary" component="p" color="supportText">
          {roleDescription}
        </Typography>
      </Grid>
      <Grid container item xs={12} direction="row-reverse" spacing={32}>
        <Grid item xs={12} md={6}>
          Salary placeholder
        </Grid>
        <Grid item xs={12} md={6}>
          <div css={styles.testimonialContainer}>
            <RoleTestimonial imageUrl={testimonialImage?.url} heading={testimonialHeading} body={testimonialBody} />
            <RelatedDegree degree={relatedDegree} />
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CareerRolePanel;
